

































import {
  computed,
  defineComponent,
  ref,
  vue3Model,
  watch
} from '~/utils/nuxt3-migration'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import CFormSelect from '~/components/shared/configurable/form/select/CFormSelect.vue'

export default defineComponent({
  model: vue3Model,
  components: {
    CFormGroup,
    CFormSelect
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const facet = ref(props.modelValue)
    const selectedLow = ref<string | null>(
      facet.value?.values?.selected?.low?.toString() || null
    )
    const selectedHigh = ref<string | null>(
      facet.value?.values?.selected?.high?.toString() || null
    )

    watch(
      () => props.modelValue,
      newValue => {
        facet.value = {
          ...facet.value,
          ...newValue
        }
        selectedLow.value =
          facet.value?.values?.selected?.low?.toString() || null
        selectedHigh.value =
          facet.value?.values?.selected?.high?.toString() || null
      }
    )

    const options = computed(() => {
      return facet.value.searchables.values.map((option: any) => {
        return {
          value: option.v,
          label: option.n
        }
      })
    })
    const lowOptions = computed(() => {
      return options.value.map((option: any) => {
        return {
          ...option,
          disabled:
            selectedHigh.value !== null &&
            compareValues(option.value, selectedHigh.value) > 0
        }
      })
    })
    const highOptions = computed(() => {
      return options.value.map((option: any) => {
        return {
          ...option,
          disabled:
            selectedLow.value !== null &&
            compareValues(option.value, selectedLow.value) < 0
        }
      })
    })
    const showFrom = computed(() => {
      return facet.value.name !== 'mileage' || facet.value.showFrom
    })
    const showTo = computed(() => {
      return facet.value.name !== 'registration' || facet.value.showTo
    })

    function handleLowChange(newLowValue: string | null) {
      emit('update:modelValue', {
        name: facet.value.urlargNames[0] + '-from',
        value: newLowValue
      })
      if (
        newLowValue &&
        selectedHigh.value !== null &&
        compareValues(newLowValue, selectedHigh.value) > 0
      ) {
        selectedHigh.value = null
      }
    }
    function handleHighChange(newHighValue: string | null) {
      emit('update:modelValue', {
        name: facet.value.urlargNames[0] + '-to',
        value: newHighValue
      })
      if (
        newHighValue &&
        selectedLow.value !== null &&
        compareValues(newHighValue, selectedLow.value) < 0
      ) {
        selectedLow.value = null
      }
    }
    function compareValues(a: string | number, b: string | number): number {
      const numA = typeof a === 'string' ? parseFloat(a) : a
      const numB = typeof b === 'string' ? parseFloat(b) : b
      return numA - numB
    }

    return {
      facet,
      selectedLow,
      selectedHigh,
      lowOptions,
      highOptions,
      showFrom,
      showTo,
      handleLowChange,
      handleHighChange
    }
  }
})
